{
    "Accessibility menu": "Erişilebilirlik Menüsü",
    "Reset settings": "Ayarları Sıfırla",
    "Close": "Kapat",
    "Content adjustments": "İçerik Ayarları",
    "Navigation adjustments": "Gezinme Ayarları",
    "Align Left": "Sola Hizala",
    "Adjust Font Size": "Yazı Tipi Boyutunu Ayarla",
    "Highlight Title": "Başlığı Vurgula",
    "Highlight Links": "Bağlantıları Vurgula",
    "Readable Font": "Okunaklı Yazı Tipi",
    "Colour adjustments": "Renk Ayarları",
    "Dark Contrast": "Koyu Kontrast",
    "Light Contrast": "Açık Kontrast",
    "High Contrast": "Yüksek Kontrast",
    "High Saturation": "Yüksek Doygunluk",
    "Low Saturation": "Düşük Doygunluk",
    "Monochrome": "Tek Renkli",
    "Tools": "Araçlar",
    "Reading Guide": "Okuma Rehberi",
    "Stop Animations": "Animasyonları Durdur",
    "Big Cursor": "Büyük İmleç",
    "Increase Font Size": "Yazı Tipi Boyutunu Artır",
    "Decrease Font Size": "Yazı Tipi Boyutunu Azalt",
    "Letter Spacing": "Harf Aralığı",
    "Line Height": "Satır Yüksekliği",
    "Font Weight": "Yazı Tipi Kalınlığı",
    "Dyslexia Font": "Disleksi Yazı Tipi",
    "Language": "Dil",
    "Accessibility widget": "Erişilebilirlik menüsünü aç",
    "Accessibility Profiles": "Erişilebilirlik Profilleri",
    "Cognitive Disability": "Bilişsel Engellilik",
    "Seizure Safe": "Nöbet Güvenli",
    "Accessibility statement": "Erişilebilirlik Beyanı"
}